import ArrowBack from "@mui/icons-material/ArrowBack";
import { IconButton, Link, LinkProps } from "@mui/material";
import React from "react";

export const GoBackButton: React.FC<LinkProps> = ({ ...props }) => {
  return (
    <Link {...props}>
      <IconButton color="primary">
        <ArrowBack />
      </IconButton>
    </Link>
  );
};
